import React from "react";
import './download.css'
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import mockupImageSrc from "images/demo/sample-medicare-card.jpg"
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-9.svg";
import { ContentWithPaddingXl, Container as ContainerBase } from "components/misc/Layouts";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import appleIconImageSrc from "images/apple-icon.png";
import googlePlayIconImageSrc from "images/google-play-icon.png"
import { Button } from "@mui/material";

const Container = tw(ContainerBase)`bg-primary-100 -mx-8 `
const Content = tw(ContentWithPaddingXl)``
const Row = tw.div`px-8 flex items-center relative z-10 flex-col lg:flex-row text-center lg:text-left justify-center`;

const ColumnContainer = tw.div`max-w-2xl`
const TextContainer = tw(ColumnContainer)``;
const Text = tw(SectionHeading)`text-primary-900 lg:text-left max-w-none text-3xl leading-snug`;
const Subheading = tw(SubheadingBase)`text-yellow-500 mb-4 tracking-wider`

const LinksContainer = tw.div`mt-8 lg:mt-16 flex flex-col items-center sm:block`
const Link = styled.a`
  ${tw`w-56 p-0 sm:p-3 text-sm sm:text-base font-bold uppercase  rounded-lg inline-flex justify-center items-center mt-0 first:mt-0 sm:mt-0 sm:ml-0 first:ml-0 bg-gray-100 hocus:bg-gray-300 text-gray-900 hocus:text-gray-900 shadow hover:shadow-lg focus:shadow-outline focus:outline-none transition duration-300`}
  img {
    ${tw`inline-block h-4 mr-3`}
  }
  span {
    ${tw`leading-none inline-block`}
  }
`;


const ImageContainer = tw(ColumnContainer)`mt-16 lg:mt-0 lg:ml-16 flex justify-end`;

const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`
const DecoratorBlob1 = tw(SvgDecoratorBlob1)`absolute bottom-0 left-0 w-80 h-80 transform -translate-x-20 translate-y-32 text-primary-800 opacity-50`
const DecoratorBlob2 = tw(SvgDecoratorBlob1)`absolute  w-80 h-80 transform translate-x-56 -translate-y-56 text-primary-800 opacity-50`
export default ({
  subheading = "Download App",
  text = "Developers all over the world are happily using Treact.",
  link1Text = "App Store",
  link1Url = "http://apple.com",
  link1IconSrc = appleIconImageSrc,
  link2Text = "Google Play",
  link2Url = "http://play.google.com",
  link2IconSrc = googlePlayIconImageSrc,
  pushDownFooter = false,
  imageSrc = mockupImageSrc,
  onClick = onClick
}) => {
  return (
    <Container css={pushDownFooter && tw`mb-20 lg:mb-24`} className='gradient'>
      <Content>
        <Row>
          <TextContainer>
            <Text>Medicare Part B Recipients Pay $0</Text>
            <Text>Health Insurance Members Pay $0</Text>
            <p style={{color:'black'}}>Claim your over-the-counter COVID-19 test from the comfort and safety of your home.</p>
          </TextContainer>
          <ImageContainer>
            <img src={imageSrc} alt="" tw="w-96"/>
          </ImageContainer>
        </Row>
        <DecoratorBlobContainer>
          <DecoratorBlob1/>
          <DecoratorBlob2/>
        </DecoratorBlobContainer>
      </Content>
    </Container>
  );
};
